export function identityResolver(value: unknown) {
  return value;
}
